<mat-sidenav-container fullscreen autosize #sidenavContainer>
  @if ((authenticated | async) !== null) {
    <mat-sidenav
      [mode]="isMobile && !sidenavCollapsed ? 'over' : 'side'"
      [ngClass]="isMobile ? 'mobile-sidenav-menu' : 'sidenav-menu'"
      #sidenav
      id="sidenav"
      [opened]="true"
      [disableClose]="true"
      >
      @if (!isMobile) {
        @if (!sidenavCollapsed) {
          <colimo-extended-sidenav [alertCount]="alertCount" [alertsConfigured]="alertsConfigured" [colimindAccess]="colimindAccess" (initiateLogout)="logout()"></colimo-extended-sidenav>
        }
        @if (sidenavCollapsed) {
          <colimo-collapsed-sidenav [alertCount]="alertCount" [alertsConfigured]="alertsConfigured" [colimindAccess]="colimindAccess"  (initiateLogout)="logout()"></colimo-collapsed-sidenav>
        }
      }
      @if (isMobile) {
        @if (!sidenavCollapsed) {
          <colimo-mobile-sidenav [alertCount]="alertCount" [alertsConfigured]="alertsConfigured" (initiateLogout)="logout()"></colimo-mobile-sidenav>
        }
      }
    </mat-sidenav>
  }

  <mat-sidenav-content class="background">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
